<!--
 * @Description: 直播录播文章列表元素样式 1:资讯 2:病例 3:直播 4:录播  5:问卷
 * @Date: 2020-09-25 15:38:11
-->
<template>
  <div @click="jump">
    <slot name="header"></slot>
    <!-- 资讯,病历 -->
    <div class="info" v-if="[3].includes(formatType)">
      <img :src="item.coverUrl || item.coverPicUrl" />
      <div>
        <p class="tit text-overflow-2">{{ item.title }}</p>
        <p class="footer">
          <span class="time">{{ item.createDt | transMonths }}</span>
          <span class="text-overflow-1">{{ item.author }}</span>
        </p>
      </div>
    </div>
    <!-- 直播 -->
    <div class="video" v-if="[1, 2].includes(formatType)">
      <div class="video__top">
        <img :src="item.waitPicUrl || item.coverPicUrl" />
      </div>
      <div class="video__text text-overflow-2">{{ item.courseName }}</div>
      <div class="video__tag" v-if="isReplay">回放</div>
    </div>
    <!-- 问卷 -->
    <div class="survey common" v-if="formatType == 5">
      <img
        :src="
          item.banner ||
            'http://cdn.yxvzb.com/WEB/SaaS/polymerization/images/defaultSurvey.png'
        "
        alt
      />
      <div class="survey-d">
        <p class="text-overflow-2">{{ item.title }}</p>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
// 菜单关联类型 1-直播 2-录播 3-文章
const jumpMap = {
  1: 'liveDetail',
  2: 'courseDetail',
  3: 'headlineDetail'
};
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    // 有的列表数据中没有type
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    formatType() {
      // 1-直播 2-录播 3-文章
      return this.item.linkType || this.type;
    },
    isReplay() {
      return this.item.isReplay === 1 && this.item.isEnd === 1;
    }
  },
  methods: {
    jump() {
      this.$router.push({
        name: jumpMap[this.formatType],
        params: {
          id: this.item.id
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.common {
  padding: 0.43rem 0;
}
.video {
  margin-bottom: 0.32rem;
  position: relative;
  &__top {
    width: 4.27rem;
    height: 2.27rem;
    border-radius: 0.16rem;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__text {
    padding: 0.17rem;
    padding-bottom: 0;
    width: 4rem;
    min-height: 1.2rem;
  }
  &__tag {
    padding: 0.07rem 0.21rem;
    background: linear-gradient(23deg, #ffb681, #ff6826);
    border-bottom-left-radius: 0.16rem;
    border-top-right-radius: 0.16rem;
    color: #fff;
    font-size: 0.32rem;
    line-height: 1;
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;
  }
}
.case,
.info {
  display: flex;
  background: #fff;
  padding: 0.31rem 0.23rem 0.45rem;
  border-bottom: 1px solid #ededed;
  width: 100%;
  img {
    width: 4.13rem;
    height: 2.33rem;
    border-radius: 0.16rem;
    margin-right: 0.37rem;
  }
  > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 4rem;
    .tit {
      font-size: 0.43rem;
      font-weight: 500;
      color: rgba(50, 50, 53, 1);
      line-height: 0.67rem;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      width: 100%;
      span {
        font-size: 0.35rem;
        color: #aeafb3;
        max-width: 3rem;
      }
    }
  }
}

.survey {
  position: relative;
  &-d {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.48);
    padding: 0.21rem 0.32rem;
    font-size: 0.37rem;
    font-weight: bold;
    color: #fff;
    line-height: 0.56rem;
    text-align: center;
    max-height: 1.55rem;
  }
  img {
    display: block;
    width: 100%;
    height: 2.61rem;
    border-radius: 0.11rem;
  }
}
</style>
